<template>
<div class="head">
   <div class="recordl" v-if="state>0 && marqueeInfo.length>0">
      <img  class="liwu" src="/static/images/lipin.png" />
      <div class="marq">
         <marquee scrollamount="3" v-if="marqueeInfo.length>0">{{marqueeInfo}}</marquee>
      </div>
   </div>
   <img src="/static/images/headtop.png" />
   <div class="lottnum">
      <span v-if="state==0">活动未开始</span>
      <span v-if="state==1">今日剩余：{{number>=0?number:0}}次</span>
      <span v-if="state==2">活动已结束</span>
   </div>
   <div class="record" v-on:click="goList" v-if="state>0">
      <img src="/static/images/lottrecord.png" />
   </div>
</div>
</template>
<script>
export default {
    //状态 0 未开始 1 开始 2结束
    //state: 0,
   props:["number","marqueeInfo","state"],
   data() {
      return {
      }
   },
   mounted() {
      
   },
   watch: {
      marqueeInfo: function(newVal,oldVal){
         this.marqueeInfo = newVal;
      }
   },
   methods:{
      //中奖列表
      goList:function(){
         this.$router.push({
               path: "/home/awardList"
         });
      },
   }
}
</script>



// WEBPACK FOOTER //
// src/components/head.vue